export const TEMPLATE_NUMBER_LIMIT = 1e19;
//# sourceMappingURL=template-number-limit.js.map